import { type APIConfig } from '../apiTypes'
import { axiosInstance } from './axiosInstance'
import * as DynamakerContract from '../../../integration/DynamakerContract'

const axios = axiosInstance()

export interface ConfigStoreResponse {
  type: 'PRESET' | 'CART' | 'SAVE' | 'OFFER'
  dmConfigData: DynamakerContract.DynaMakerConfigurationSavefileBlob
  dmConfigurationSections: DynamakerContract.SectionedBOM
  dmMetadata: DynamakerContract.Metadata
  yassConfigId: string
  yassConfigHashKey: string
}

export const getLoadconfig = async (args: {
  apiConfigs: APIConfig
  data: {
    configId: string
    configHashKey: string
    extrafields: any
  }
}): Promise<ConfigStoreResponse> => {
  const { configstoreApiBaseUrl } = args.apiConfigs
  const { configHashKey, configId, extrafields } = args.data

  const response = await axios.get<ConfigStoreResponse>(`${configstoreApiBaseUrl}/loadconfig/${configId}/${configHashKey}`, {
    params: { extrafields },
  })
  .catch((error) => {
    console.error(error)
    throw new Error(JSON.stringify(error))
  })

  return response.data
}
